export default __webpack_public_path__ + "static/media/hours-icon-big.dd923af3.svg";